document.addEventListener("DOMContentLoaded", function () {

    function initGallery() {

        const slider = document.querySelector(".Product__Slideshow");
        const thumbnails = document.querySelectorAll(".Product__SlideshowNavImage");

        if (!slider || thumbnails.length === 0) {
            return;
        }

        const flkty = Flickity.data(slider);

        if (!flkty) {
            console.log("Flickity instance not found");
            return;
        }

        // Thumbnail click
        thumbnails.forEach(function (thumb, index) {

            thumb.addEventListener("click", function (e) {

                e.preventDefault();

                flkty.select(index);

                thumbnails.forEach(function (item) {
                    item.classList.remove("is-selected");
                });

                thumb.classList.add("is-selected");

            });

        });

        // Slider change
        flkty.on("change", function (index) {

            thumbnails.forEach(function (item) {
                item.classList.remove("is-selected");
            });

            if (thumbnails[index]) {
                thumbnails[index].classList.add("is-selected");
            }

        });

    }

    // Wait for theme
    setTimeout(initGallery, 500);

});